import locale from '../web-sh/src/locale';

import en from './en.json';
import vi from './vi.json';
import zh from './zh.json';
import ru from './ru.json';
import fr from './fr.json';

const mergeJsonContent = (oldData, newData) => {
  if (!newData) {
    return oldData
  }
  if (typeof oldData !== 'object') {
    return newData || oldData
  }
  const jsonData = { ...oldData, ...newData }
  const keys = Object.keys(jsonData)
  keys.forEach(key => {
    jsonData[key] = mergeJsonContent(oldData[key], newData[key])
  });
  return jsonData;
}

export default {
  mergeJsonContent,
  en: mergeJsonContent(locale.en, en),
  vi: mergeJsonContent(locale.vi, vi),
  zh: mergeJsonContent(locale.zh, zh),
  ru: mergeJsonContent(locale.ru, ru),
  fr: mergeJsonContent(locale.fr, fr),
}